export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const X_API_KEY = process.env.REACT_APP_BO_API_KEY;
export const TTS_URL = process.env.REACT_APP_TTS_URL;
export const STT_URL = process.env.REACT_APP_STT_URL;
export const AUDIO_URL = process.env.REACT_APP_AUDIO_URL;
export const MULTIPLAYER_URL = process.env.REACT_APP_MULTIPLAYER_URL;
export const MULTIPLAYER_PORT = process.env.REACT_APP_MULTIPLAYER_PORT;